// components
import { ReportPageChatUI } from "@components/ReportPage"
// assets
import ReportMaker from "@assets/ReportPage/ReportMaker.png"

export const ReportPageChatSection = () => (
    <div className="flex flex-col gap-4  px-6 py-7 bg-[var(--bg-theme-lightest)] rounded-2xl overflow-hidden">
        <div className="flex items-center gap-3 px-4">
            <img
                src={ReportMaker}
                alt={`type exercise`}
                className="flex items-center justify-center size-10 object-contain"
            />
            <div className="flex flex-col gap-1 text-[var(--text-light-gray)]">
                <span className="font-bold text-xs leading-4">
                    Orby-Score Report Maker
                </span>
                <span className="text-xs leading-4">
                    Select the option provided to view insights
                </span>
            </div>
        </div>
        <ReportPageChatUI />
    </div>
)
